<template>
  <div class="settings-css manage">
    <div
      v-if="!checkPermission('manage_settings') || forbidden" >
      <h1 class="settings__title">
        Working hours
      </h1>
      <Forbidden />
    </div>
    <div
      v-else-if="!forbidden && business && business.name"
      class="settings--limit-width">
      <div class="flex align-start space-between">
        <h1 class="settings__title">
          Working hours
        </h1>

        <div>
          <multiselect
            v-model="timezone"
            class="flex-options hide-tags no-selected-background"
            :options="timezones"
            :multiple="false"
            :show-labels="false"
            :show-no-results="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="false"
            :allow-empty="false"
            :searchable="true" >
            <template
              slot="singleLabel"
              slot-scope="props">
              <div class="flex flex-align-center">
                <SBIcon
                  class="globe"
                  :icon="SBIconList.GLOBE"
                  :color="SBColors.blackPrimary"
                  :size="12"/>
                <span
                  class="multiselect__single" >{{props.option}}</span>
              </div>
            </template>
            <template
              slot="option"
              slot-scope="props">
              {{ props.option }}
            </template>
          </multiselect>
        </div>
      </div>

      <!-- <InfoCard
        v-if="!errorMessage && initialTagsRequestFinished && !false"
        :flat-icon="SBIconList.WORKING_HOURS_LOGO"
        title="Let your customers know when to expect a response"
        description="Set your operating hours so your customers know when to expect a reply. Contacts that message this number will receive an automated welcome or away message, indicating that you are open or closed for business.

          If you don’t specify hours here, we’ll default to an always-on (24/7) schedule."
        action-text="Add hours"
        @action="" /> -->

      <Spinner
        v-if="loadingWorkingHours"
        class="mt-5"
        :thickness="2" />

      <SettingsNote
        v-else-if="errorMessage"
        :icon="SBIconList.ERROR"
        text="Error loading data..." />

      <template v-else>
        <!-- JUST SAVED FOR NOW - we can't do it because backend can't support this feature for now. Continue and finish once it will be available. -->
        <!-- TODO - make component from this -->
        <!-- <div class="attention-note">
          <SBIcon
            :icon="SBIconList.ERROR"
            :color="SBColors.blackPrimary"
            :size="12" />
          <p>Hours are set for the time zone <b>Europe/Ljubljana</b>. If you don’t specify hours here, we'll default to analways-on (24/7) schedule.</p>
        </div> -->

        <!-- <ValidationObserver
          ref="customFieldObserver"
          v-slot="{ valid, dirty, pristine }" >
          <div
            v-for="(wh, index) in workingHours"
            :key="index"
            class="work-hour flex center-all gap-10">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              tag="div"
              class="w-100" >
              <multiselect
                v-model="wh.day"
                class="flex-options hide-tags no-selected-background"
                :options="days"
                :multiple="false"
                :show-labels="false"
                :show-no-results="false"
                :close-on-select="true"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="false"
                :searchable="true"
                label="text"
                track-by="value" >
                <template
                  slot="option"
                  slot-scope="props">
                  <SBIcon
                    class="globe"
                    :icon="SBIconList.DONE_TICK"
                    :color="SBColors.bluePrimary"
                    :size="9"/>
                  {{ props.option.text }}
                </template>
              </multiselect>
            </ValidationProvider>

            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              tag="div"
              class="w-100" >
              <multiselect
                v-model="wh.from"
                class="flex-options hide-tags no-selected-background"
                :options="timeIntervals"
                :multiple="false"
                :show-labels="false"
                :show-no-results="false"
                :close-on-select="true"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="false"
                :searchable="true"
                label="name"
                track-by="value" >
                <template
                  slot="option"
                  slot-scope="props">
                  <SBIcon
                    class="globe"
                    :icon="SBIconList.DONE_TICK"
                    :color="SBColors.bluePrimary"
                    :size="9"/>
                  {{ props.option.name }}
                </template>
              </multiselect>
            </ValidationProvider>
            <span>to</span>

            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              tag="div"
              class="w-100" >
              <multiselect
                v-model="wh.to"
                class="flex-options hide-tags no-selected-background"
                :options="timeIntervals"
                :multiple="false"
                :show-labels="false"
                :show-no-results="false"
                :close-on-select="true"
                :clear-on-select="false"
                :preserve-search="true"
                :allow-empty="false"
                :searchable="true"
                label="name"
                track-by="value" >
                <template
                  slot="option"
                  slot-scope="props">
                  <SBIcon
                    class="globe"
                    :icon="SBIconList.DONE_TICK"
                    :color="SBColors.bluePrimary"
                    :size="9"/>
                  {{ props.option.name }}
                </template>
              </multiselect>
            </ValidationProvider>

            <SwitchCheckbox
              id="UserAvailabilitySwitch"
              :value="!true"
              class="dropdown-check"
              size="mini no-label-margin"
              :outline-color="SBColors.bluePrimary"
              :switch-color="SBColors.white"
              :off-outline-color="SBColors.greyLight"
              :off-switch-color="SBColors.white"
              @input="() => {}"/>
          </div>

          <div
            class="add-option-btn"
            @click="addOption">
            <span class="flex flex-align-center">
              <SBIcon
                class="mr-2"
                :icon="SBIconList.PLUS"
                :color="SBColors.bluePrimary"
                :size="8" />
              <span>Add option</span>
            </span>
          </div>

          <FooterActions
            :form-valid="valid"
            :has-changes="dirty"
            :show-cancel="!pristine"
            :save-busy="saving"
            @reset="resetChanges"
            @save="updateWorkingHours" />
        </ValidationObserver> -->


        <!-- NEW version with v1 backend functionality -->
        <!-- TODO - make component from this -- YELLOW NOTE -->
        <!-- <div class="attention-note">
          <SBIcon
            :icon="SBIconList.ERROR"
            :color="SBColors.blackPrimary"
            :size="12" />
          <p>Hours are set for the time zone <b>Europe/Ljubljana</b>. If you don’t specify hours here, we'll default to analways-on (24/7) schedule.</p>
        </div> -->

        <SettingsNote
          :icon="SBIconList.GLOBE"
          :title="noteTitle" />

        <div>
          <multiselect
            v-model="workingHoursType"
            class="flex-options no-selected-background type-selector"
            :options="workingHoursTypes"
            :multiple="false"
            :show-labels="false"
            :show-no-results="false"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :allow-empty="false"
            :searchable="true"
            label="text"
            track-by="value" >
            <template
              slot="option"
              slot-scope="props">
              <SBIcon
                class="globe"
                :icon="SBIconList.DONE_TICK"
                :color="SBColors.bluePrimary"
                :size="9"/>
              {{ props.option.text }}
            </template>
          </multiselect>
        </div>

        <ValidationObserver
          ref="customFieldObserver"
          v-slot="{ valid, dirty }" >
          <template v-if="workingHoursType.value === 'custom'">
            <div
              v-for="(day, index) in ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']"
              :key="index"
              :class="{closed: !availabilitiesLocal[day].available}"
              class="work-hour flex center-all gap-10">
              <ValidationProvider
                rules="required"
                tag="div"
                class="w-31" >
                <div
                  :class="{ active: availabilitiesLocal[day].available }"
                  class="static item flex center-all" >
                  <span
                    class="keyword greedy ellipsis mr-2 flex flex-align-center day" >
                    {{ day }}
                  </span>
                  <div>
                    <SwitchCheckbox
                      v-model="availabilitiesLocal[day].available"
                      size="micro"
                      class="no-label-margin"
                      :outline-color="SBColors.blackPrimary"
                      :off-outline-color="SBColors.blackUltralight"
                      :value="availabilitiesLocal[day].available"
                      @click.native.stop />
                  </div>
                </div>
              </ValidationProvider>

              <!-- In case the number is closed for the whole day. -->
              <template v-if="!availabilitiesLocal[day].available">
                <div
                  class="static item flex center-all greedy" >
                  <span
                    class="keyword greedy ellipsis mr-2 flex flex-align-center" >
                    Closed for business
                  </span>
                </div>
              </template>

              <!-- In case number is available. -->
              <template v-else>
                <ValidationProvider
                  rules="required"
                  tag="div"
                  class="w-100" >
                  <multiselect
                    v-model="availabilitiesLocal[day].from"
                    class="flex-options hide-tags no-selected-background"
                    :options="[...timeIntervals].slice(0, -1)"
                    :multiple="false"
                    :show-labels="false"
                    :show-no-results="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :allow-empty="false"
                    :searchable="true"
                    label="name"
                    track-by="value"
                    @input="validateTable" >
                    <template
                      slot="option"
                      slot-scope="props">
                      <SBIcon
                        class="globe"
                        :icon="SBIconList.DONE_TICK"
                        :color="SBColors.bluePrimary"
                        :size="9"/>
                      {{ props.option.name }}
                    </template>
                  </multiselect>
                </ValidationProvider>

                <span class="to">to</span>

                <ValidationProvider
                  rules="required"
                  tag="div"
                  class="w-100"
                  mode="aggressive" >
                  <multiselect
                    v-model="availabilitiesLocal[day].to"
                    class="flex-options hide-tags no-selected-background"
                    :options="filterTimeIntervals(day)"
                    :multiple="false"
                    :show-labels="false"
                    :show-no-results="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :allow-empty="false"
                    :searchable="true"
                    label="name"
                    track-by="value" >
                    <template
                      slot="option"
                      slot-scope="props">
                      <SBIcon
                        class="globe"
                        :icon="SBIconList.DONE_TICK"
                        :color="SBColors.bluePrimary"
                        :size="9"/>
                      {{ props.option.name }}
                    </template>
                  </multiselect>
                </ValidationProvider>
              </template>
            </div>
          </template>

          <FooterActions
            :form-valid="valid && (timezoneWaitingForUpdate || typeWaitingForUpdate || workingForHoursWaitingForUpdate)"
            :has-changes="dirty || timezoneWaitingForUpdate || typeWaitingForUpdate || workingForHoursWaitingForUpdate"
            :show-cancel="timezoneWaitingForUpdate || typeWaitingForUpdate || workingForHoursWaitingForUpdate"
            :save-busy="saving"
            @reset="resetChanges"
            @save="updateWorkingHours" />
        </ValidationObserver>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';

import timezones from '@/helpers/lists/timezones';
import timeIntervals from '@/helpers/lists/timeIntervals';
import ToasterMixin from '@/mixins/Toaster';
import Spinner from '../../common/Spinner';
import NoPermissionMixin from '@/mixins/AccessPermission';
import SettingsNote from './partials/SettingsNote';
import FooterActions from './partials/FooterActions';
import SwitchCheckbox from '@/components/common/SwitchCheckbox';
import UserPermissionsMixin from '@/mixins/UserPermissions.mixin';

export default {
  name: 'WorkingHoursSettings',
  components: {
    Spinner,
    SettingsNote,
    SwitchCheckbox,
    Multiselect,
    FooterActions,
  },
  mixins: [
    ToasterMixin,
    NoPermissionMixin,
    UserPermissionsMixin,
  ],
  data() {
    return {
      errorMessage: '',
      // days: [
      //   { text: 'Every day', value: 'every-day' },
      //   { text: 'Weekdays (Mon - Fri)', value: 'week-day' },
      //   { text: 'Weekends (Sat - Sun)', value: 'week-end' },
      //   { text: 'Monday', value: 'Monday' },
      //   { text: 'Tuesday', value: 'Tuesday' },
      //   { text: 'Wednesday', value: 'Wednesday' },
      //   { text: 'Thursday', value: 'Thursday' },
      //   { text: 'Friday', value: 'Friday' },
      //   { text: 'Saturday', value: 'Saturday' },
      //   { text: 'Sunday', value: 'Sunday' },
      // ],
      typeBackup: {},
      availabilitiesLocalBackup: {},
      availabilitiesLocal: {},
      saving: false,
      // workingHours: [],
      loadingWorkingHours: true,
      workingHoursTypes: [
        { text: 'Always open', value: '24/7' },
        { text: 'Custom working hours', value: 'custom' },
      ],
      workingHoursType: { text: 'Always open', value: '24/7' },
      timezone: 'UTC',
      timezones,
      timeIntervals,
      currentAvailabilities: {},
    };
  },
  computed: {
    ...mapGetters({
      apiError: 'merchant/apiError',
      availabilities: 'merchant/availabilities',
      currentOrganisation: 'organisation/currentOrganisation',
      userPermissions: 'user/userPermissions',
      businessAvailabilityChange: 'pusher/businessAvailabilityChange',
    }),
    business() {
      return this.currentOrganisation.businesses.find(b => b.id === this.$route.params.businessId);
    },
    organisationId() {
      return this.$route.params.organisationId;
    },
    // Returns true if timezone is changed. Change is detected if it is different than what is set on the business.
    // Had to use currentOrganisation because prop was not reactive
    timezoneWaitingForUpdate() {
      const targetBusiness = this.currentOrganisation.businesses.find(business => business.id === this.business.id);
      return targetBusiness.timezone !== this.timezone;
    },
    typeWaitingForUpdate() {
      return !this.$lodash.isEqual({ ...this.typeBackup }, { ...this.workingHoursType });
    },
    workingForHoursWaitingForUpdate() {
      return this.workingHoursType.value !== '24/7' && !this.$lodash.isEqual({ ...this.availabilitiesLocalBackup }, { ...this.availabilitiesLocal });
    },
    businessTimeZone() {
      const targetBusiness = this.currentOrganisation.businesses.find(business => business.id === this.business.id);
      return targetBusiness.timezone;
    },
    noteTitle() {
      return `Hours are set for the time zone ${this.businessTimeZone}.`;
    },
  },
  watch: {
    apiError(error) {
      this.errorMessage = error.data.message;
    },
    business() {
      if (this.checkPermission('manage_settings') && this.business.id) {
        this.loadingWorkingHours = true;
        this.fetchWorkingHours({
          organisationId: this.organisationId,
          businessId: this.business.id,
        })
          .then((response) => {
            if (response.status === 200) {
              this.setLocalAvailabilities();
            }
          })
          .finally(() => {
            this.loadingWorkingHours = false;
          });

        this.timezone = this.business.timezone;
      }
    },
    businessAvailabilityChange() {
      const waitingOnUpdate = Object.keys(this.currentAvailabilities);
      this.currentOrganisation.businesses.forEach((b) => {
        if (waitingOnUpdate.includes(b.id) && (b.available !== this.currentAvailabilities[b.id])) {
          if (b.available) {
            this.showToaster(`<span class="emoji-fix">🟢</span> ${b.name} is now open for business`, null, null);
          } else {
            this.showToaster(`<span class="emoji-fix">🔴</span> ${b.name} is now closed for business`, null, null);
          }
        }
        delete this.currentAvailabilities[b.id];
      });
    },
    userPermissions() {
      if (this.checkPermission('manage_settings') && this.business.id) {
        this.loadingWorkingHours = true;
        this.fetchWorkingHours({
          organisationId: this.organisationId,
          businessId: this.business.id,
        })
          .then((response) => {
            if (response.status === 200) {
              this.setLocalAvailabilities();
            }
          })
          .finally(() => {
            this.loadingWorkingHours = false;
          });

        this.timezone = this.business.timezone;
      }
    },
  },
  mounted() {
    this.finalizeSplashView();
    // in case user returns to the page. On first mount business is undefined so this will not trigger
    if (this.checkPermission('manage_settings') && this.business.id) {
      this.fetchWorkingHours({
        organisationId: this.organisationId,
        businessId: this.business.id,
      })
        .then((response) => {
          if (response.status === 200) {
            this.setLocalAvailabilities();
          }
        })
        .finally(() => {
          this.loadingWorkingHours = false;
        });

      this.timezone = this.business.timezone;
    }
  },
  methods: {
    ...mapActions({
      finalizeSplashView: 'organisation/finalizeSplashView',
      fetchWorkingHours: 'merchant/fetchWorkingHours',
      updateAvailabilityTimes20: 'merchant/updateAvailabilityTimes20',
    }),
    // addOption() {
    //   this.workingHours.push();
    // },
    resetChanges() {
      this.timezone = this.business.timezone;
      this.workingHoursType = JSON.parse(JSON.stringify(this.typeBackup));
      this.availabilitiesLocal = JSON.parse(JSON.stringify(this.availabilitiesLocalBackup));
    },
    updateWorkingHours() {
      this.saving = true;
      const submitAvailabilitiesFormat = {};

      if (this.workingHoursType.value === '24/7') {
        ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].forEach((day) => {
          submitAvailabilitiesFormat[day] = {};
          submitAvailabilitiesFormat[day].from = '09:00:00';
          submitAvailabilitiesFormat[day].to = '17:00:00';
          submitAvailabilitiesFormat[day].available = true;

          this.availabilitiesLocal[day].from = this.timeIntervals.find(interval => interval.value === '09:00:00');
          this.availabilitiesLocal[day].to = this.timeIntervals.find(interval => interval.value === '17:00:00');
          this.availabilitiesLocal[day].available = true;
        });
      } else {
        ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].forEach((day) => {
          submitAvailabilitiesFormat[day] = {};
          submitAvailabilitiesFormat[day].from = this.availabilitiesLocal[day].from.value;
          submitAvailabilitiesFormat[day].to = this.availabilitiesLocal[day].to.value;
          submitAvailabilitiesFormat[day].available = this.availabilitiesLocal[day].available;
        });
      }

      let data = {
        timezone: this.timezone,
        availabilities: submitAvailabilitiesFormat,
      };

      if (this.workingHoursType.value === '24/7') {
        data = {
          timezone: this.timezone,
          always_open: true,
        };
      }

      this.currentAvailabilities[this.business.id] = this.currentOrganisation.businesses.find(b => b.id === this.business.id).available;
      this.updateAvailabilityTimes20({
        organisationId: this.organisationId,
        businessId: this.business.id,
        data,
      })
        .then((response) => {
          if (response.status === 200) {
            this.setLocalAvailabilitiesAfterSave();
            this.showToaster('Working hours have been successfully updated', null, null, 'OK');
          }
        })
        .finally(() => {
          this.saving = false;
        });
    },
    filterTimeIntervals(day) {
      const filteredIntervals = Object.values(this.$lodash.pickBy(this.timeIntervals, intervalName => intervalName.value > this.availabilitiesLocal[day].from.value));

      if (
        !this.availabilitiesLocal[day].to ||
        (this.availabilitiesLocal[day].to && !filteredIntervals.find(interval => interval.value === this.availabilitiesLocal[day].to.value))
      ) {
        this.$set(this.availabilitiesLocal[day], 'to', filteredIntervals[0] ? filteredIntervals[0] : null);
      }

      return filteredIntervals;
    },
    validateTable() {
      if (this.$refs.customFieldObserver) {
        this.$nextTick(() => {
          this.$refs.customFieldObserver.validate();
        });
      }
    },
    setLocalAvailabilities() {
      // Check if 24/7
      if (this.availabilities.always_open) {
        this.workingHoursType = this.workingHoursTypes[0];
        ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].forEach((day) => {
          this.$set(this.availabilitiesLocal, day, {});
          this.$set(this.availabilitiesLocal[day], 'to', this.timeIntervals.find(interval => interval.value === '17:00:00'));
          this.$set(this.availabilitiesLocal[day], 'from', this.timeIntervals.find(interval => interval.value === '09:00:00'));
          this.$set(this.availabilitiesLocal[day], 'available', true);
        });
      } else {
        this.workingHoursType = this.workingHoursTypes[1];
        this.availabilities.forEach((day) => {
          this.$set(this.availabilitiesLocal, day.day, {});
          this.$set(this.availabilitiesLocal[day.day], 'to', this.timeIntervals.find(interval => interval.value === day.to));
          this.$set(this.availabilitiesLocal[day.day], 'from', this.timeIntervals.find(interval => interval.value === day.from));
          this.$set(this.availabilitiesLocal[day.day], 'available', day.available);
        });
      }

      this.typeBackup = { ...this.workingHoursType };

      // spread syntax creates only shallow copy.
      this.availabilitiesLocalBackup = JSON.parse(JSON.stringify(this.availabilitiesLocal));
    },
    setLocalAvailabilitiesAfterSave() {
      this.availabilitiesLocalBackup = JSON.parse(JSON.stringify(this.availabilitiesLocal));
      this.availabilitiesLocalBackup = { ...this.availabilitiesLocalBackup };
      this.typeBackup = JSON.parse(JSON.stringify(this.workingHoursType));
      this.typeBackup = { ...this.typeBackup };
    },
  },
};
</script>

<style lang="scss" scoped>
.globe {
  margin-right: 6px;
  margin-left: 6px;
}

// .attention-note {
//   display: flex;
//   justify-content: start;
//   align-items: center;
//   margin: 20px 0;
//   padding: 15px;
//   border-radius: 5px;
//   border: solid 1px #f5edce;
//   background-color: #fff7dd;

//   .sb-icon {
//     margin-right: 15px;
//   }

//   p {
//     font-size: 14px;
//     font-weight: 400;
//   }
// }

.work-hour {
  margin-bottom: 10px;
}

.work-hour {
  .w-31 {
    width: 100% !important;
    max-width: 31% !important;
  }

  .item, ::v-deep .multiselect__tags, ::v-deep .multiselect__tags .multiselect__single, ::v-deep .multiselect__tags input {
    background-color: #f8fffe !important;
  }

  &.closed {
    .item, ::v-deep .multiselect__tags {
      background-color: $greyUltralight !important;
    }
  }

  .item {
    padding: 0 10px;
    border-radius: 5px;
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
    border: solid 1px $greyBorder;
    height: 32px;
    background: $white;

    .keyword {
      font-size: 14px;
      font-weight: 400;
      color: $blackPrimary;
      min-height: 20px;

      &.day {
        font-weight: 500;
        text-transform: capitalize;
      }
    }

    .keyword-input {
      cursor: pointer;
      padding: 0;
      border: none;
      box-shadow: none;
      margin-right: 10px;

      &:focus {
        border: none !important;
        box-shadow: none !important;
      }
    }

    // .sb-icon.on-parent-hover {
    //   display: none;
    // }

    // &:hover .sb-icon.on-parent-hover {
    //   display: flex;

    //   &.trash:hover .mask {
    //     background-color: $blackPrimary !important;
    //   }
    // }

    &.static .response-keyword {
      font-weight: 500;
    }

    &.hide {
      display: none !important;
    }
  }
}

.type-selector {
  margin: 20px 0;
}

.to {
  font-size: 14px;
  color: $greyPrimary;
}

// Make a component out of this
::v-deep .add-option-btn {
  width: max-content;
  color: $bluePrimary;

  span {
    font-weight: 500;
    font-size: 14px;
  }

  &:hover {
    cursor: pointer;
    color: $blackPrimary;
    .sb-icon .mask {
      background-color: $blackPrimary !important;
    }
  }
}
</style>
